import Vue from 'vue';
// 骑手列表
export const getriderlist = params => Vue.axios.get('/traveller/rider/getriderlist', { params }).then(res => res.data);
// 订单列表
export const getorderlist = params => Vue.axios.get('/traveller/order/getorderlist', { params }).then(res => res.data);



// WEBPACK FOOTER //
// ./src/pages/homepage/api/index.js